import $ from "jquery";
import imagesLoaded from "imagesloaded";

import LangSelector from "./components/lang-selector";
import SiteHeader from "./components/site-header";
import HomeSlider from "./components/home-slider";
import ReviewsSlider from "./components/reviews-slider";
import HandheldMenu from "./components/handheld-menu";
import CookiesConsent from "./components/cookies-consent";
import DropdownMenu from "./components/dropdown-menu";
import Accordion from "./components/accordion";
import Gallery from "./components/gallery";
import ScrollInView from "./components/scroll-in-view";
import CategorySlider from "./components/category-product-slider";
import MaterialsSlider from "./components/materials-slider";
import SwatchesSliders from "./components/swatches-slider";
import FavoritesProduct from "./components/favorites-product";
import DeviceManager from "./utils/device-manager";
import GallerySlider from "./components/gallery";
import RelatedProductsSlider from "./components/related-products-slider";
import ComplementaryFiles from "./components/complementary-files";
import CustomVariations from "./components/custom-variations";
import "./components/popup-variations-colors";
import LoadMore from "./components/load-more";
import Quantity from "./components/quantity";

// (function ($) {
// window.$ = $;

$(function () {
  const bootstrapApp = () => {
    const $html = $("html");

    // Touch device detection
    if (DeviceManager.isHandheld()) {
      $html.addClass("touch");

      if (DeviceManager.isIos()) {
        $html.addClass("ios");
      }
    } else {
      $html.addClass("no-touch");
    }

    // IE detection
    if (DeviceManager.isIe11()) {
      $html.addClass("ie11");
    } else if (DeviceManager.isEdge()) {
      $html.addClass("edge");
    }
  };

  const instanciateComponents = () => {
    // General components
    const langSelector = new LangSelector($(".language-selector"));
    const siteHeader = new SiteHeader($(".site-header"), 20);

    // Home slider component
    const $homesSliders = $(".homepage-slider");
    if ($homesSliders.length) {
      $homesSliders.each(function (index, el) {
        const homeSlider = new HomeSlider($(el));
      });
    }

    // Related products slider component
    const $RelatedProductSliders = $(".upsells > ul.products");
    if ($RelatedProductSliders.length) {
      $RelatedProductSliders.each(function (index, el) {
        const relatedProductSlider = new RelatedProductsSlider($(el));
      });
    }

    // Swatches slider component
    const $SwatchesSliders = $(".tawcvs-swatches");
    if ($SwatchesSliders.length) {
      $SwatchesSliders.each(function (index, el) {
        const swatchSlider = new SwatchesSliders($(el));
      });
    }

    // Gallery slider component
    setTimeout(() => {
      const $GallerySliders = $(".flex-control-thumbs");
      if ($GallerySliders) {
        $GallerySliders.each(function (index, el) {
          const gallerySlider = new GallerySlider($(el));
        });
      }
    }, 500);

    // Materials slider component
    const $MaterialsSliders = $(".materials__container");
    if ($MaterialsSliders.length) {
      $MaterialsSliders.each(function (index, el) {
        const materialSlider = new MaterialsSlider($(el));
      });
    }

    // Favorites products slider component
    const $favoritesSliders = $(".favorites-products__container");
    if ($favoritesSliders.length) {
      $favoritesSliders.each(function (index, el) {
        const favoriteSlider = new FavoritesProduct($(el));
      });
    }

    // News slider component
    const $categorySliders = $(".category-shop__categories-container");
    if ($categorySliders.length) {
      $categorySliders.each(function (index, el) {
        const categorySlider = new CategorySlider($(el));
      });
    }

    // Reviews slider component
    const $reviewsSlider = $(".reviews-slider");
    if ($reviewsSlider.length) {
      $reviewsSlider.each(function (index, el) {
        const reviewsSlider = new ReviewsSlider($(el));
      });
    }

    // Cookie consent
    if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
      // Tarteaucitron cookie settings
      let tarteaucitronLang = "fr";

      const cookiesConsent = new CookiesConsent(tarteaucitronLang);
    }

    // Scroll in view component
    const $scrollInViewElements = $(".scroll-in-view");
    if ($scrollInViewElements.length) {
      $scrollInViewElements.imagesLoaded(function () {
        const scrollInView = new ScrollInView($scrollInViewElements);
      });
    }

    let cartNb = $(".cart-number.has-item");
    let cartMenu = $(".cart--icon");
    cartNb.appendTo(cartMenu);
  };

  bootstrapApp();
  instanciateComponents();
});

// })(jQuery);
